import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { useChatStore } from './store/chat.js';
import './styles.css';

/**
 * 개발 빌드에서만 스토어를 노출한다.
 *
 * 오피스 뷰의 아바타는 캔버스에 그려져서 DOM으로는 위치를 볼 수 없다.
 * 브라우저 테스트가 좌표를 확인하려면 이 통로가 필요하다.
 * import.meta.env.DEV는 프로덕션 빌드에서 상수 false로 치환되어
 * 이 블록째로 사라진다.
 */
if (import.meta.env.DEV) {
  (globalThis as Record<string, unknown>)['__sokdaqStore'] = useChatStore;
}

const container = document.getElementById('root');
if (!container) throw new Error('#root 엘리먼트를 찾을 수 없습니다');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
